import { PropsWithChildren, useState } from "react";
import { createStore } from "zustand";

import { ShortlistsStoreType } from "./shortlists_store.types";
import { getInitialShortlistsState, ShortlistsStoreContext } from "./shortlists_store_context";

export const ShortlistsStoreProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(() =>
    createStore<ShortlistsStoreType>()((set) => {
      const initialState = getInitialShortlistsState();

      return {
        ...initialState,
        actions: {
          updateShortlistsParams: (params) =>
            set((state) => ({
              shortlistsParams: {
                ...state.shortlistsParams,
                ...params
              }
            })),
          setShortlistsParams: (shortlistsParams) => set({ shortlistsParams }),
          resetShortlistsParams: () => set({ shortlistsParams: getInitialShortlistsState().shortlistsParams })
        }
      };
    })
  );

  return <ShortlistsStoreContext.Provider value={store}>{children}</ShortlistsStoreContext.Provider>;
};
